import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { House, Book, MapTrifold, GameController, Trophy, Chat, FolderOpen } from 'phosphor-react';
import { useUserStore } from '../../store/userStore';

export const Header = () => {
  const location = useLocation();
  const { points, level } = useUserStore();

  const navItems = [
    { path: '/', label: 'الرئيسية', icon: House },
    { path: '/lessons', label: 'الدروس', icon: Book },
    { path: '/map', label: 'الخريطة', icon: MapTrifold },
    { path: '/games', label: 'الألعاب', icon: GameController },
    { path: '/awards', label: 'الجوائز', icon: Trophy },
    { path: '/library', label: 'المكتبة', icon: FolderOpen },
    { path: '/chat', label: 'اسأل زيزو', icon: Chat },
  ];

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-[1200]">
        <div className="relative bg-gradient-to-r from-cyan-50/90 via-yellow-50/90 to-pink-50/90 backdrop-blur-xl border-b border-white/65 shadow-[0_14px_40px_rgba(56,189,248,0.2)]">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-cyan-300 via-lime-300 to-rose-300" />
          <div className="container mx-auto px-4 py-3">
            <div className="flex items-center justify-between gap-4">
              <Link to="/" className="flex items-center gap-3">
                <motion.div
                  initial={{ rotate: -8, scale: 0.9, opacity: 0 }}
                  animate={{ rotate: [0, -4, 4, 0], y: [0, -2, 0], scale: [1, 1.05, 1], opacity: 1 }}
                  transition={{ duration: 3, repeat: Infinity, repeatType: 'mirror', ease: 'easeInOut' }}
                  className="w-11 h-11 rounded-2xl bg-gradient-to-br from-cyan-400 via-emerald-400 to-orange-400 text-white flex items-center justify-center shadow-[0_12px_24px_rgba(244,114,182,0.35)]"
                >
                  <span className="text-xl">🏛️</span>
                </motion.div>
                <div>
                  <h1 className="text-xl font-black tracking-tight text-slate-900">كنوز مصر</h1>
                  <p className="text-xs text-slate-600">تعلم الجغرافيا بطريقة ممتعة للأطفال</p>
                </div>
              </Link>

              <nav className="hidden md:flex items-center gap-1 glass-panel px-2 py-2">
                {navItems.map((item) => {
                  const Icon = item.icon;
                  const isActive = location.pathname === item.path;

                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`relative flex items-center gap-2 px-4 py-2 rounded-2xl text-sm font-black transition-all duration-300 ${
                        isActive
                          ? 'bg-gradient-to-r from-cyan-300 via-lime-300 to-pink-300 text-slate-900 shadow-[0_12px_24px_rgba(244,114,182,0.28)]'
                          : 'text-slate-700 hover:bg-white/90 hover:text-sky-700 hover:-translate-y-0.5'
                      }`}
                    >
                      <Icon size={18} weight={isActive ? 'fill' : 'regular'} />
                      <span>{item.label}</span>
                    </Link>
                  );
                })}
              </nav>

              <div className="hidden md:flex items-center gap-2">
                <div className="chip">
                  <span className="text-slate-600">النقاط</span>
                  <span className="number font-black text-slate-900">{points}</span>
                </div>
                <div className="chip chip-strong">
                  <span className="text-white/80">المستوى</span>
                  <span className="number font-black">{level}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile dock */}
      <nav className="md:hidden fixed bottom-4 left-4 right-4 z-50 glass-panel px-3 py-2 border-white/80">
        <div className="flex items-center justify-between">
          {navItems.slice(0, 5).map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center gap-1 px-2 py-1 rounded-2xl transition-all duration-300 ${
                  isActive
                    ? 'bg-gradient-to-r from-cyan-300 via-lime-300 to-pink-300 text-slate-900 shadow-[0_8px_18px_rgba(244,114,182,0.25)]'
                    : 'text-slate-700'
                }`}
              >
                <Icon size={22} weight={isActive ? 'fill' : 'regular'} />
                <span className="text-[10px] font-semibold">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
};
